module.exports = __webpack_public_path__ + "static/media/location-pin-blk.a6b49b41.png";